import "./App.css";
import Tasks from "./pages/tasks";
import Theme from "./styles/theme";

function App() {
  return (
    <Theme>
      <Tasks />
    </Theme>
  );
}

export default App;
